export default __webpack_public_path__ + "static/media/carousel-right.ff59c5ce.svg";